// Marks each copied paragraph's wrapper `<div>` in larry's outbound clipboard HTML, so the paste
// parsers can tell larry's own paragraph boundaries from foreign markup.
export const PASTE_PARA_ATTR = 'data-paste-para'

// Browsers do not hand back the exact bytes that were written to the clipboard: they wrap the
// payload in `<html>`/`<body>` and mark the copied selection with these comments. Everything
// outside them is the browser's own framing, never copied content.
//
// Shared rather than inlined in each parser on purpose (WMPCM-10131): both clipboard readers
// must agree on what "the payload" is. They previously disagreed — only the external parser
// sliced on these, so framing whitespace reached the internal parser as real paragraph breaks.
export const CLIPBOARD_FRAGMENT_START = '<!--StartFragment-->'
export const CLIPBOARD_FRAGMENT_END = '<!--EndFragment-->'
